module.exports = __webpack_public_path__ + "static/media/Starbucks-03.a20bca93.png";